import React, { useState } from "react";
import ClickNHold from "react-click-n-hold";
import { Modal } from "antd";
import {
  getHoursMinutesTime,
  trimDoubleQuotes,
} from "../../../constant/helper";
import AvatarPreview from "../../profile/components/AvatarPreview";
import MessageActions from "./MessageActions";
import MessageDateCategories from "./MessageDateCategories";
import { scrollTo } from '../utils/scrollTo'

const MessageLawyer = ({
  data,
  time,
  messagesList,
  index,
  currentlyItem,
  meta,
}) => {
  const { text, inReplyToTheMessage } = data;
  const { id } = meta;
  const [showDropdown, setShowDropdown] = useState(false);

  const startShowDialog = () => {
  };
  const endShowDialog = () => {
  };
  const showDialog = () => {
    setShowDropdown(true);
  };

  return (
    <>
      <div className={"msg"} style={{ marginRight: "auto" }} id={id}>
        <MessageDateCategories
          className={{
            textAlign: "center",
            color: "#656567",
            fontWeight: "400",
            fontSize: "14px",
            marginBottom: "1rem",
          }}
          messagesList={messagesList}
          index={index}
          currentlyItem={currentlyItem}
        />
        <ClickNHold
          time={1} // Time to keep pressing. Default is 2
          onStart={startShowDialog}
          onClickNHold={showDialog}
          onEnd={endShowDialog}
          className="msg-wrapper"
        >
          <>
            {inReplyToTheMessage && (
              <div className="msg-in-reply-text" onClick={() => scrollTo(data.inReplyToTheMessage.id)}>
                {trimDoubleQuotes(
                  inReplyToTheMessage.text || inReplyToTheMessage.filename
                )}
              </div>
            )}
            {text && <div className="msg-text">{trimDoubleQuotes(text)}</div>}
            <div className={"msg-avatar-bg"}>
              <div className={"msg-avatar-holder"}>
                <AvatarPreview
                  isSvg={false}
                  src={currentlyItem.otherProfile || "LAWONE"}
                />{" "}
              </div>
            </div>
            <div className={"msg-time"}>
              {" "}
              {time && getHoursMinutesTime(time)}{" "}
            </div>
          </>
        </ClickNHold>
      </div>

      <Modal
        visible={showDropdown}
        onCancel={() => setShowDropdown(false)}
        centered
        footer={null}
        closable={false}
        wrapClassName="chat-modal-wrapper"
      >
        {/* <div className="chat-page chat-modal">
          <div className="chat-holder">
            <div className={"msg"}>
              <div className="msg-wrapper">
                {text && <div className="msg-text">{text}</div>}
                <div className={"msg-avatar-bg"}>
                  <div className={"msg-avatar-holder"}>
                    <AvatarPreview
                      isSvg={false}
                      src={currentlyItem.otherProfile || "LAWONE"}
                    />{" "}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}
        <MessageActions
          isCopy
          messageId={id}
          text={text ? text : ""}
          closeActions={() => setShowDropdown(false)}
        />
      </Modal>
    </>
  );
};

export default MessageLawyer;
